import { useCallback, useEffect } from 'react';

import { useRouter } from 'next/router';

import {
  useMembership,
  useAccountActions,
  useCustomerDetails,
} from '../../techstyle-shared/react-accounts';
import { useMarketingActions } from '../../techstyle-shared/react-marketing';
import {
  useSessionDetail,
  useSessionActions,
  useSession,
} from '../../techstyle-shared/redux-core';
import { SignupMemberships } from '../constants/memberships';

const useGshop = () => {
  const { isLoggedIn } = useSession();
  const { isVip } = useMembership();
  const accountActions = useAccountActions();
  const sessionActions = useSessionActions();
  const marketingActions = useMarketingActions();

  const { query: { promo = '' } = {} } = useRouter();

  const [
    gShopCustomerDetail,
    gShopMSRPCustomerDetail,
    gShopMSRPDiscountCustomerDetail,
  ] = useCustomerDetails([
    SignupMemberships.GSHOP,
    SignupMemberships.GSHOP_MSRP,
    SignupMemberships.GSHOP_MSRP_DISCOUNT,
  ]);
  let isGshopInCustomerDetails = false;
  let isGshopMSRPInCustomerDetails = false;
  let isGshopMSRPDiscountInCustomerDetails = false;
  if (isLoggedIn) {
    if (gShopCustomerDetail) {
      isGshopInCustomerDetails = true;
    }

    if (gShopMSRPCustomerDetail) {
      isGshopMSRPInCustomerDetails = true;
    }

    if (gShopMSRPDiscountCustomerDetail) {
      isGshopMSRPDiscountInCustomerDetails = true;
    }
  }
  const isGshopInSessionDetails =
    useSessionDetail(SignupMemberships.GSHOP)?.value === '1';
  const isGshopMSRPInSessionDetails =
    useSessionDetail(SignupMemberships.GSHOP_MSRP)?.value === '1';
  const isGshopMSRPDiscountInSessionDetails =
    useSessionDetail(SignupMemberships.GSHOP_MSRP_DISCOUNT)?.value === '1';

  useEffect(() => {
    if (isGshopInSessionDetails && !isGshopInCustomerDetails && isLoggedIn) {
      accountActions.updateCustomerDetail({
        name: SignupMemberships.GSHOP,
        value: '1',
        datetimeAdded: new Date(),
      });
    }

    if (
      isGshopMSRPInSessionDetails &&
      !isGshopMSRPInCustomerDetails &&
      isLoggedIn
    ) {
      accountActions.updateCustomerDetail({
        name: SignupMemberships.GSHOP_MSRP,
        value: '1',
        datetimeAdded: new Date(),
      });
    }

    if (
      isGshopMSRPDiscountInSessionDetails &&
      !isGshopMSRPDiscountInCustomerDetails &&
      isLoggedIn &&
      !isVip
    ) {
      accountActions.updateCustomerDetail({
        name: 'lead_introductory_offer',
        value: SignupMemberships.GSHOP_MSRP_DISCOUNT.toLowerCase(),
        datetimeAdded: new Date(),
      });
    }
  }, [
    isLoggedIn,
    accountActions,
    isGshopInSessionDetails,
    isGshopInCustomerDetails,
    isGshopMSRPInSessionDetails,
    isGshopMSRPInCustomerDetails,
    isGshopMSRPDiscountInSessionDetails,
    isGshopMSRPDiscountInCustomerDetails,
    isVip,
    marketingActions,
  ]);

  const isGshopActive = isGshopInSessionDetails || isGshopInCustomerDetails;
  const isGshopMSRPActive =
    isGshopMSRPInSessionDetails || isGshopMSRPInCustomerDetails;
  const isGshopMSRPDiscountActive =
    isGshopMSRPDiscountInSessionDetails || isGshopMSRPDiscountInCustomerDetails;
  const isGshopInQuery = promo.toLowerCase().includes('gshop');

  const activateGshop = useCallback(() => {
    let detailName = SignupMemberships.GSHOP;

    if (promo.toUpperCase() === SignupMemberships.GSHOP_MSRP) {
      detailName = SignupMemberships.GSHOP_MSRP;
    } else if (promo.toUpperCase() === SignupMemberships.GSHOP_MSRP_DISCOUNT) {
      detailName = SignupMemberships.GSHOP_MSRP_DISCOUNT;
    }

    // activate GSHOP in sessionDetail if ?promo=gshop is in query and user is not VIP
    if (isGshopInQuery && !isVip) {
      sessionActions.updateSessionDetail({
        name: detailName,
        value: '1',
      });
    }

    // deactivate GSHOP in sessionDetail and customerDetail once customer signs up for VIP
    if (isGshopActive && isVip) {
      sessionActions.updateSessionDetail({
        name: detailName,
        value: '0',
      });

      accountActions.updateCustomerDetail({
        name: detailName,
        value: '0',
        datetimeAdded: new Date(),
      });
    }
  }, [
    promo,
    isGshopInQuery,
    isVip,
    isGshopActive,
    sessionActions,
    accountActions,
  ]);

  return {
    isGshopActive,
    isGshopMSRPActive,
    isGshopMSRPDiscountActive,
    activateGshop,
  };
};

export default useGshop;
